module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-384.b9b504e.woff2";